export default "__VITE_ASSET__b29286d7__"